.container {
  margin-bottom: 1rem;
}

.toggleRow {
  padding: 1rem 0;
}

.emailRow {
  display: grid;
  grid-template-rows: 1fr;
}

/* A new row slides down: the track grows from 0fr to 1fr, so the height animates without being measured. */
.emailRowEnter {
  animation: emailRowEnter 200ms ease-out;
}

.emailRowEnter > .emailGrid {
  min-height: 0;
  overflow: hidden;
}

@keyframes emailRowEnter {
  from {
    grid-template-rows: 0fr;
    opacity: 0;
    transform: translateY(-0.5rem);
  }

  to {
    grid-template-rows: 1fr;
    opacity: 1;
    transform: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .emailRowEnter {
    animation: none;
  }

  .emailRowEnter > .emailGrid {
    overflow: visible;
  }
}

.emailGrid {
  align-items: end;
  display: grid;
  gap: 1rem;
  /* The language select takes the width of its longest option, so "English" is never cut off. */
  grid-template-columns: minmax(0, 1fr) max-content 3rem;
  padding-bottom: 1rem;
}

.emailInputContainer {
  margin: 0;
}

.emailField {
  margin-bottom: 0;
}

.responderRow {
  align-items: center;
  display: flex;
  margin-bottom: 0.125rem;
}

.statusIcon {
  display: inline-flex;
  flex-shrink: 0;
}

.statusPositive {
  color: var(--color-positive);
}

.statusMediocre {
  color: var(--color-waiting);
}

.responderMeta {
  margin-left: 0.5rem;
}

.responderStatus {
  margin-left: 0.25rem;
}

.responded {
  color: var(--color-text);
  font-weight: 600;
}

.resent {
  margin-left: 0.5rem;
}

.notSent {
  color: var(--color-error);
  font-weight: 600;
}

.anonymousInfo {
  margin: 0 0 1rem;
}

.qrCode {
  margin-top: 0.5rem;
}

.invitationText {
  margin: 0;
  white-space: pre-wrap;
}

.languageSelector {
  margin-bottom: 0;
}
